
import React from 'react';
import RelacionamentosExternos from './RelacionamentosExternos';
import Filter from '../../../Auxiliar/Filter';

const SelecionarJsRelacionamentosExternos = () => {
    const [search, setSearch] = React.useState(false)
    const [dateOf, setDateOf] = React.useState('')
    const [dateFor, setDateFor] = React.useState('')
    const [options, setOptions] = React.useState({
        relacionamentosExternos: { value: true, label: 'Tabela de Relacionamentos', checked: true },
    })
    
    return (
        <div className="card">
            <div className="card-body" id="card">
                <div className="d-flex align-items-start">
                    <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>Relacionamentos Externos</h4>
                    <Filter setDateOf={setDateOf} setDateFor={setDateFor} options={options} setOptions={setOptions} setSearch={setSearch} />
                </div>
                <div>
                    <p style={{ fontSize: '1rem', color: 'black' }}>Aqui são listados os relacionamentos externos (Blueen Open)</p>
                </div>
                <div className="row">
                    {options.relacionamentosExternos.value &&
                        <RelacionamentosExternos dateOf={dateOf} dateFor={dateFor} search={search} setSearch={setSearch} />}
                </div>
            </div>
        </div>
    )
}

export default SelecionarJsRelacionamentosExternos
